import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import initActionsCreator from './redux/tierContentInit';
import TierContent from '../TierContent';

export const getTierContentWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: TierContent,
  initActionsCreator,
});
